import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Routes } from "../app/Routes";
import { I18nProvider } from "../_metronic/i18n";
import { PageTitleProvider } from "./contexts/PageTitle";
import { AuthProvider } from "./contexts/Auth";
import { SnackProvider } from "./contexts/Snack";
import 'moment/locale/es-mx';
import moment from "moment";
import { FeatureAccessProvider } from "./contexts/FeaturesAccess";
import AdapterMoment from '@material-ui/lab/AdapterMoment';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import './helpers/extensions/string.extensions.js';
import './helpers/extensions/array.extensions.js';

import { pdfjs } from "react-pdf";
import { toAbsoluteUrl } from "../_metronic/_helpers";
import * as oqt from "./helpers";
moment.locale("es-mx");

console.log(Object.keys(oqt).join("\n"))
//const pdfjs = await import('pdfjs-dist/build/pdf');
//const pdfjsWorker = import('./pdf.worker.js');

pdfjs.GlobalWorkerOptions.workerSrc = toAbsoluteUrl(`js/pdf.worker.js`);

document.addEventListener("wheel", function(event){
  const numberInput = (document.activeElement);
  if (numberInput.type === "number") {
    numberInput.blur();
  }
});

export default function App({ basename }) {
  return (
    <BrowserRouter basename={basename}>
        <I18nProvider>
          <PageTitleProvider>
            <AuthProvider>
              <SnackProvider>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <FeatureAccessProvider>
                    <Routes />
                  </FeatureAccessProvider>
                </LocalizationProvider>
              </SnackProvider>
            </AuthProvider>
          </PageTitleProvider>
        </I18nProvider>
    </BrowserRouter>
  );
}